export default {
    init() {
        this.typeFileToggle();
    },

    typeFileToggle(){
        var select_val = $('.user-data-field-type').select2().val();

        if(select_val == 'file'){
            $('.user_type_file-select-wrap').removeClass('hidden');
        } else {
            $('.user_type_file-select-wrap').addClass('hidden');
        }
        
        if(select_val == 'file' || select_val == 'date'){
            $('.user_type_file_or_date-select-wrap').addClass('hidden');
        } else {
            $('.user_type_file_or_date-select-wrap').removeClass('hidden');
        }

        $(".user-data-field-type").on("select2:select", function (e) {
            var select_val = $(e.currentTarget).val();
            if(select_val == 'file'){
                $('.user_type_file-select-wrap').removeClass('hidden');
            } else {
                $('.user_type_file-select-wrap').addClass('hidden');
            }

            if(select_val == 'file' || select_val == 'date'){
                $('.user_type_file_or_date-select-wrap').addClass('hidden');
            } else {
                $('.user_type_file_or_date-select-wrap').removeClass('hidden');
            }
        });
    },
}